<template>
  <UiTooltip
    :placement="placement"
    :tooltip-class="tooltipClass"
    :transition="transition"
  >
    <template #trigger="">
      <slot />
    </template>
    <span role="dialog" class="jps-text-tooltip is-size-6">{{ ls(text) }}</span>
  </UiTooltip>
</template>

<script lang="ts" setup>
import type { Placement } from '@popperjs/core'

const { ls } = useI18n()

interface Props {
  text: LangString
  placement?: Placement
  tooltipClass?: string
  transition?: string
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
.jps-text-tooltip {
  display: block;
  max-width: 14rem;
  padding: 0.75rem;
}
</style>
